import type { PrimeVueLocaleOptions } from 'primevue'

export const pl: PrimeVueLocaleOptions = {
    cancel: 'Anuluj',
    choose: 'Wybierz',
    chooseDate: 'Wybierz datę',
    clear: 'Wyczyść',
    contains: 'Zawiera',
    dateAfter: 'Data przypada po',
    accept: 'Tak',
    dateBefore: 'Data przypada przed',
    showMonthAfterYear: false,
    dateFormat: 'dd.mm.yy',
    addRule: 'Dodaj regułę',
    dateIs: 'Równa',
    dateIsNot: 'Nierówna',
    chooseYear: 'Wybierz rok',
    dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    chooseMonth: 'Wybierz miesiąc',
    dayNamesMin: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    dayNamesShort: ['Ndz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
    emptyFilterMessage: 'Brak wyników wyszukiwania',
    emptyMessage: 'Nie ma dostępnych opcji',
    apply: 'Zastosuj',
    emptySearchMessage: 'Nie znaleziono wyników',
    emptySelectionMessage: 'Brak wybranego elementu',
    endsWith: 'Kończy się na',
    equals: 'Równe',
    completed: 'Ukończone',
    prevDecade: 'Poprzednia dekada',
    prevHour: 'Poprzednia godzina',
    prevMinute: 'Poprzednia minuta',
    prevMonth: 'Poprzedni miesiąc',
    prevSecond: 'Poprzednia sekunda',
    prevYear: 'Poprzedni rok',
    reject: 'Nie',
    nextMinute: 'Następna minuta',
    nextMonth: 'Następny miesiąc',
    nextSecond: 'Następna sekunda',
    nextYear: 'Następny rok',
    noFileChosenMessage: 'Nie wybrano pliku',
    noFilter: 'Wyczyść filtr',
    notContains: 'Nie zawiera',
    removeRule: 'Usuń regułę',
    searchMessage: 'Dostępnych jest {0} wyników',
    selectionMessage: 'Wybrano {0} elementów',
    startsWith: 'Zaczyna się od',
    strong: 'Silny',
    today: 'Dzisiaj',
    upload: 'Wgraj',
    weak: 'Słaby',
    fileChosenMessage: '{0} plików',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    firstDayOfWeek: 1,
    gt: 'Większe od',
    gte: 'Większe lub równe',
    lt: 'Mniejsze od',
    lte: 'Mniejsze lub równe',
    matchAll: 'Dopasuj wszystko',
    matchAny: 'Dopasuj dowolne',
    medium: 'Średni',
    monthNames: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
    ],
    monthNamesShort: [
        'Sty',
        'Lut',
        'Mar',
        'Kwi',
        'Maj',
        'Cze',
        'Lip',
        'Sie',
        'Wrz',
        'Paź',
        'Lis',
        'Gru',
    ],
    nextDecade: 'Następna dekada',
    nextHour: 'Następna godzina',
    notEquals: 'Nierówne',
    passwordPrompt: 'Wprowadź hasło',
    pending: 'Oczekuje',
    pm: 'PM',

    weekHeader: 'Tydzień',
    aria: {
        expandRow: 'Rozwniń wiersz',
        collapseRow: 'Zwniń wiersz',
        cancelEdit: 'Anuluj edycję',
        close: 'Zamknij',

        editRow: 'Edycja wiersza',
        falseLabel: 'Fałsz',
        filterConstraint: 'Ograniczenie filtra',
        filterOperator: 'Operator filtra',
        firstPageLabel: 'Pierwsza strona',
        gridView: 'Widok siatki',
        hideFilterMenu: 'Ukryj menu filtrów',
        jumpToPageDropdownLabel: 'Przejdź do menu rozwijanego strony',
        jumpToPageInputLabel: 'Przejdź do wprowadzania strony',
        lastPageLabel: 'Ostatnia strona',
        listLabel: 'Lista opcji',
        listView: 'Widok listy',
        moveAllToSource: 'Przenieś wszystko do źródła',
        moveAllToTarget: 'Przenieś wszystko do celu',
        moveBottom: 'Przesuń w dół',
        moveDown: 'Położyć',
        moveTop: 'Przesuń do góry',
        moveToSource: 'Przenieś do źródła',
        moveToTarget: 'Przenieś do celu',
        moveUp: 'Podnieść',
        navigation: 'Nawigacja',
        next: 'Następny',
        nextPageLabel: 'Następna strona',
        nullLabel: 'Nie zaznaczone',
        pageLabel: 'Strona {page}',
        previous: 'Poprzedni',
        prevPageLabel: 'Poprzednia strona',
        rotateLeft: 'Obróć w lewo',
        rotateRight: 'Obróć w prawo',
        rowsPerPageLabel: 'Wierszy na stronę',
        saveEdit: 'Zapisz edycję',
        scrollTop: 'Przewiń do góry',
        selectAll: 'Wszystkie elementy zaznaczone',
        selectRow: 'Wiersz zaznaczony',
        showFilterMenu: 'Pokaż menu filtrów',
        slide: 'Slajd',
        slideNumber: '{slideNumber}',
        star: '1 gwiazdka',
        stars: '{star} gwiazdek',
        trueLabel: 'Prawda',
        unselectAll: 'Wszystkie elementy odznaczone',
        unselectRow: 'Wiersz odznaczony',
        zoomImage: 'Powiększ obraz',
        zoomIn: 'Przybliż',
        zoomOut: 'Oddal',
    },
}
